export {PandaEngine,PandaOptions,PandaCommponent,PandaAnimation,PandaEvent} from './panda.js';
export {PandaMode,MaterialType} from './enums.js';
import init,{compress, decompress, freeBuffer} from 'wasm-gzip';
import localforage from 'localforage';

init();

localforage.config({
  name:'panda',
  storeName:'panda'
})

export {compress,decompress,freeBuffer};
